import React from 'react';
import { skeletonVariants } from './skeleton.css';
import { Box } from '../box/box';
import clsx from 'clsx';

type SkeletonProps = {
  variant?: 'text' | 'rect' | 'circle';
  width?: number | string;
  height?: number | string;
  css?: React.CSSProperties;
  className?: string;
};

export const Skeleton = ({ variant = 'rect', width, height, css, className }: SkeletonProps) => {
  const skeletonVar = variant && skeletonVariants[variant];

  return <Box className={clsx(skeletonVar, className)} css={{ ...css, width, height }} />;
};
